<script>
  import ValidationMessage from '../../../components/form/ValidationMessage.vue'
  import * as restfulService from '../../../services/restfulService'
  import {required, requiredIf, email} from 'vuelidate/lib/validators'
  import helperMixin from '../../../../mixins/helper'
  import {clone} from 'lodash'
  import {mapGetters} from 'vuex'
  import bus from '@utils/bus'

  export default {
    components: {ValidationMessage},
    mixins: [helperMixin],
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        isLoginOpened: false,
        actionName: '',
        dependencies: {
          events: []
        },
        form: {
          event_id: '',
          cpf: '',
          rg: '',
          matricula: '',
          birth_date: '',
          password: ''
        },
        personalData: {
          data: {
            ref_pessoa: '',
            ref_cidade: '',
            nome: '',
            cep: '',
            rua: '',
            numero: '',
            complemento: '',
            bairro: '',
            email: '',
            email_alternativo: '',
            senha: '',
            senha_confirmacao: ''
          }
        },
        physicalData: {
          data: {
            sexo: 'M',
            fone_residencial: '',
            fone_celular: '',
            fone_recado: '',
            rg_numero: '',
            cpf: '',
            dt_nascimento: '',
            ref_naturalidade: '',
            ref_nacionalidade: '',
            ref_estado_civil: '',
            ref_raca: '',
            necessidades_especiais: [],
            nome_pai: '',
            nome_mae: '',
            link_lattes: ''
          }
        }
      }
    },
    computed: {
      ...mapGetters(['isLogged', 'currentUser']),
      eventWebsite: function () {
        return this.dependencies.events.filter((item) => {
          return item.id === this.form.event_id
        })[0]
      }
    },
    validations: {
      form: {
        event_id: {required},
        cpf: {
          required: requiredIf(function () {
            return this.actionName === 'cpf'
          })
        },
        rg: {
          required: requiredIf(function () {
            return this.actionName === 'rg'
          })
        },
        birth_date: {
          required: requiredIf(function () {
            return this.actionName === 'cpf' || this.actionName === 'rg'
          })
        },
        matricula: {
          required: requiredIf(function () {
            return this.actionName === 'matricula'
          })
        },
        password: {
          required: requiredIf(function () {
            return this.actionName === 'matricula'
          })
        }
      },
      personalData: {
        data: {
          nome: {required},
          email: {required, email},
          cep: {required},
          email_confirmacao: {
            required: requiredIf(function () {
              return this.personalData.data.email
            })
          },
          email_alternativo: {email},
          rua: {required},
          numero: {required},
          bairro: {required},
          ref_cidade: {required},
          senha: {
            required: requiredIf(function () {
              return !this.personalData.data.ref_pessoa
            })
          },
          senha_confirmacao: {
            required: requiredIf(function () {
              return this.personalData.data.senha
            })
          }
        }
      },
      physicalData: {
        data: {
          sexo: {required},
          fone_celular: {required},
          dt_nascimento: {required},
          cpf: {
            required: requiredIf(function () {
              return !this.physicalData.data.rg_numero
            })
          },
          rg_numero: {
            required: requiredIf(function () {
              return !this.physicalData.data.cpf
            })
          },
          nome_mae: {required},
          ref_nacionalidade: {required}
        }
      }
    },
    mounted () {
      // Buscar os eventos ativos na API
      restfulService.get('event', 'available')
        .then((response) => {
          this.dependencies.events = response
          this.isLoadingData = false
          bus.$emit('hide-loader')
        })
        .catch(e => {
          this.isLoadingData = false
          bus.$emit('hide-loader')
          console.log(e)
        })
    },
    methods: {
      /**
       * Mostra o box de login por cpf/rg
       * @param actionName
       */
      openLogin (actionName) {
        this.form = {}
        this.$v.form.$reset()
        if (actionName !== this.actionName) {
          this.$nextTick(() => {
            if (actionName === 'cpf') {
              this.$refs.formCpf.$el.children['formCpf'].focus()
            } else if (actionName === 'rg') {
              this.$refs.formRg.$el.children['formRg'].focus()
            }
          })
          this.actionName = actionName
          this.form.type = actionName
          this.isLoginOpened = true
        } else {
          this.isLoginOpened = !this.isLoginOpened
        }
      },
      /**
       * Inicia o processo de registro
       * Envia os dados para a API que verifica se o cadastro existe no Segue
       * Caso sim, retorna os dados da pessoa e preenche os campos com os dados do Segue.
       * Caso não, o formulário é mostrado em branco para o usuário preencher todos os campos obrigatórios
       */
      onStartRegistration () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = clone(this.form)
        data.type = this.actionName
        if (!this.isLogged) {
          data.birth_date = this.dateFormat(data.birth_date, 'en')
        } else {
          data.type = 'logged'
          data.matricula = this.currentUser.ref_pessoa
          delete data.cpf
          delete data.rg
        }
        restfulService.post('registration/start', null, null, data)
          .then((response) => {
            // response.event_id = data.event_id
            if (!response.personalData) {
              response.physicalData = {}
              if (data.type === 'cpf' || data.type === 'rg') {
                response.physicalData.dt_nascimento = data.birth_date
                if (data.type === 'cpf') {
                  response.physicalData.cpf = data.cpf
                } else {
                  response.physicalData.rg_numero = data.rg_numero
                }
              }
            }
            let personData = {
              personalData: {data: this.personalData.data},
              physicalData: {data: this.physicalData.data},
              eventData: {data: {}}
            }
            if (response.personalData) {
              personData.personalData.data = response.personalData
            }
            if (response.physicalData) {
              personData.physicalData.data = response.physicalData
            }
            if (response.eventData) {
              personData.eventData.data = response.eventData
            }
            this.handlePersonData(personData)
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.isSubmitted = false
            console.log(e)
          })
      },
      /**
       * Trata os dados de retorno da API para passar o usuário para a etapa correta.
       * Caso algum campo obrigatório esteja faltando, ele é redirecionado para a etapa que está com dados faltando
       * @param person
       */
      handlePersonData (person) {
        let routeForward = 'registration.store.personal'
        this.personalData.data = {...this.personalData.data, ...person.personalData.data}
        this.physicalData.data = {...this.physicalData.data, ...person.physicalData.data}

        // Possui email, então o email é copiado para o email de confirmação para passar na validação
        if (this.personalData.data.email) {
          this.personalData.data.email_confirmacao = this.personalData.data.email
          person.personalData.data.email_confirmacao = person.personalData.data.email
        }

        if (this.$v.personalData.data.$invalid) {
          // Alguns dados básicos da pessoa estão faltando, é redirecionado para a etapa dos dados básicos
          routeForward = 'registration.store.personal'
        } else if (this.$v.physicalData.data.$invalid && !this.$v.personalData.data.$invalid) {
          // Alguns dados da pessoa física estão faltando, é redirecionado para a etapa dos dados fisicos
          routeForward = 'registration.store.physical'
        } else if (
          !this.$v.physicalData.data.$invalid &&
          !this.$v.personalData.data.$invalid &&
          this.personalData.data.ref_pessoa !== null &&
          this.personalData.data.ref_pessoa !== ''
        ) {
          // Os dados da pessoa estão todos completos, se continua para finalizar a inscrição
          routeForward = 'registration.store.event'
        }
        this.$router.push({name: routeForward, params: {registration: person}})
      }
    }
  }
</script>

<template>
    <div>
        <div class="registration-box">
            <figure class="logo">
                <img src="https://urcamp.edu.br/site/img/logos/logo-preto.png" alt="">
            </figure>
            <h1>Sistema de Eventos</h1>
            <p class="init-text">Se você é aluno da URCAMP entre com a sua matrícula, se você participou de versões
                anterioes do Congrega
                ou quer se inscrever pela primeira vez, escolha um dos documentos para fazer a sua inscrição! </p>
            <div class="registration-event">
                <h2 class="new-registration" v-if="!isLogged">Registrar-se com:</h2>
                <div class="icons"
                     v-show="!isLogged">
                    <a href="#"
                       @click="openLogin('cpf')"
                       class="icon icon-cpf">
                        <h2>CPF</h2>
                        <figure>
                            <img src="/img/icon-cpf.png" alt="">
                        </figure>
                    </a>
                    <a href="#"
                       @click="openLogin('rg')"
                       class="icon icon-ci">
                        <h2>RG</h2>
                        <figure>
                            <img src="/img/icon-document.png" alt="">
                        </figure>
                    </a>
                    <a href="#"
                       v-if="false"
                       @click="openLogin('matricula')"
                       class="icon icon-matricula">
                        <h2>Matrícula</h2>
                        <figure>
                            <img src="/img/icon-login.png" alt="">
                        </figure>
                    </a>
                </div>

                <el-form ref="form"
                         v-show="isLoginOpened || isLogged"
                         :model="form"
                         label-position="top">
                    <el-row class="event-select">
                        <el-col :span="24">
                            <el-form-item label="Evento"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.form.event_id.$error }">
                                <el-select v-model="form.event_id"
                                           clearable
                                           size="large"
                                           placeholder="Selecione o evento"
                                           empty-text="Nenhum registro encontrado"
                                           class="el-select-full"
                                           @input="$v.form.event_id.$touch()">
                                    <el-option
                                            v-for="item in dependencies.events"
                                            :key="item.id"
                                            :label="item.title"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <validation-message v-if="$v.form.event_id.$error"/>
                            <el-form-item v-if="form.event_id && eventWebsite.website"
                                          class="event-website">
                                <p>Para ler o regulamento, <strong>acesse o site do evento: <a
                                        :href="eventWebsite.website" target="_blank">Clicando
                                    aqui</a></strong></p>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="12">
                            <el-form-item label="CPF"
                                          v-show="actionName === 'cpf' && !isLogged"
                                          class="is-required hide"
                                          v-bind:class="{ 'el-form-item--error': $v.form.cpf.$error }">
                                <el-input v-model="form.cpf"
                                          size="large"
                                          type="phone"
                                          placeholder="Digite seu CPF"
                                          v-mask="'###.###.###-##'"
                                          name="formCpf"
                                          ref="formCpf"
                                          @input="$v.form.cpf.$touch()"
                                          @keyup.enter.native="onRegistration"/>
                                <validation-message v-if="$v.form.cpf.$error"/>
                            </el-form-item>
                            <el-form-item label="RG"
                                          v-show="actionName === 'rg' && !isLogged"
                                          class="is-required hide"
                                          v-bind:class="{ 'el-form-item--error': $v.form.rg.$error }">
                                <el-input v-model="form.rg"
                                          size="large"
                                          type="phone"
                                          placeholder="Digite seu RG"
                                          name="formRg"
                                          ref="formRg"
                                          @input="$v.form.rg.$touch()"
                                          @keyup.enter.native="onRegistration"/>
                                <validation-message v-if="$v.form.rg.$error"/>
                            </el-form-item>
                            <el-form-item label="Matrícula"
                                          v-show="actionName === 'matricula' && !isLogged"
                                          class="is-required hide"
                                          v-bind:class="{ 'el-form-item--error': $v.form.matricula.$error }">
                                <el-input v-model="form.matricula"
                                          size="large"
                                          type="phone"
                                          placeholder="Digite sua Matrícula"
                                          name="formMatricula"
                                          ref="formMatricula"
                                          @input="$v.form.matricula.$touch()"
                                          @keyup.enter.native="onRegistration"/>
                                <validation-message v-if="$v.form.matricula.$error"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Data de Nascimento"
                                          v-show="(actionName === 'cpf' || actionName === 'rg') && !isLogged"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.form.birth_date.$error }">
                                <el-date-picker
                                        v-model="form.birth_date"
                                        size="large"
                                        type="date"
                                        format="dd/MM/yyyy"
                                        v-mask="'##/##/####'"
                                        placeholder="Data de Nascimento"
                                        @change="$v.form.birth_date.$touch()"
                                        @keyup.enter.native="onRegistration">
                                </el-date-picker>
                                <validation-message v-if="$v.form.birth_date.$error"/>
                            </el-form-item>
                            <el-form-item label="Senha"
                                          v-show="actionName === 'matricula'"
                                          class="is-required"
                                          v-bind:class="{ 'el-form-item--error': $v.form.password.$error }">
                                <el-input size="large"
                                          type="password"
                                          v-model="form.password"
                                          placeholder="Senha"
                                          @input="$v.form.password.$touch()"
                                          @keyup.enter.native="onRegistration">
                                    <validation-message v-if="$v.form.password.$error"/>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-row :span="24">
                            <div class="buttons">
                                <el-button type="success"
                                           size="large"
                                           class="btn-start-registration"
                                           @click="onStartRegistration"
                                           :disabled="isSubmitted || $v.form.$invalid">
                                    Inscrever-se
                                </el-button>
                            </div>
                        </el-row>
                    </el-row>
                </el-form>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>

    .new-registration {
        text-align: center;
    }

    .btn-start-registration[disabled] {
        background-color: #8a8a8a !important;
        border-color: #8a8a8a !important;
        color: #DDD !important;
        cursor: not-allowed !important;
    }

    .registration-box {
        width: 80%;
        margin: 60px auto 0;
        overflow: hidden;

        .icons {
            display: table;
            border-collapse: collapse;
            margin-top: 50px;
            width: 100%;
            .icon {
                text-decoration: none;
                display: table-cell;
                border: 1px solid #e7e7e7;
                width: 33.333%;
                -ms-transition: all .4s ease-in-out;
                -webkit-transition: all .4s ease-in-out;
                transition: all .4s ease-in-out;
                h2 {
                    text-align: center;
                    -ms-transition: all .4s ease-in-out;
                    -webkit-transition: all .4s ease-in-out;
                    transition: all .4s ease-in-out;
                    font-size: 26px;
                }
                figure {
                    display: block;
                    width: 60%;
                    margin: 0 auto;
                    padding-bottom: 20px;
                    img {
                        display: block;
                        margin: 0 auto;
                        max-width: 100%;
                        max-height: 80px;
                    }
                }
                &:hover {
                    background-color: #00a65a;
                    h2 {
                        color: #FFF;
                    }
                }
            }
        }

        .logo {
            img {
                margin: 0 auto;
                display: block;
                width: 300px;
                max-width: 100%;
            }
        }

        h1 {
            text-align: center;
            color: #4c4c4c;
            font-size: 28px;
            letter-spacing: -1px;
            font-weight: 200;
        }

        .init-text {
            width: 60%;
            margin: 0 auto;
            color: #6d6d6d;
            text-align: center;
            font-size: 17px;
            padding: 0 10px;
        }

        .event-website {
            line-height: normal;
            padding: 2px 0 15px;
            margin: 0;
            p {
                margin: 0;
                a {
                    color: #00a65a;
                    text-decoration: none;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }

        .registration-event {
            width: 100%;
            padding: 20px;

            .logo {
                img {
                    margin: 0 auto;
                    display: block;
                    width: 300px;
                    max-width: 100%;
                }
            }

            h1 {
                text-align: center;
                color: #4c4c4c;
                font-size: 28px;
                letter-spacing: -1px;
                font-weight: 200;
            }
            p {
                color: #6d6d6d;
                text-align: center;
                font-size: 17px;
                padding: 0 10px;
            }
            .icons {
                width: 70%;
                margin: 0 auto;
            }

            .el-form {
                border: 1px solid #e7e7e7;
                padding: 20px;
                width: 50%;
                margin: 25px auto;

                input {
                    height: 56px;
                }

                .buttons {
                    text-align: center;

                    button {
                        display: block;
                        width: 100%;
                        padding: 16px 20px;
                        font-size: 26px;
                        font-weight: 200;
                        letter-spacing: -1px;
                    }
                }
            }
        }
        .registration-short-course {
            width: 40%;
            height: 300px;
            border-top: 1px solid #CCC;
            border-right: 1px solid #CCC;
            border-bottom: 1px solid #CCC;
            float: right;

            > h2 {
                text-align: center;
                color: #D07236;
                font-size: 35px;
                letter-spacing: -2px;
                font-weight: 200;
                margin-bottom: 10px;
            }
            p {
                color: #6d6d6d;
                text-align: center;
                font-size: 15px;
                padding: 0 20px;
            }
            .icons {
                width: 70%;
                margin: 0 auto;
                .icon {
                    width: 50%;
                    h2 {
                        font-size: 22px;
                    }
                    figure {
                        width: 40%;
                    }
                    &:hover {
                        background-color: #D07236;
                        h2 {
                            color: #FFF;
                        }
                    }
                }
            }

        }
        .registration-bank-slip {
            width: 40%;
            height: 300px;
            border-right: 1px solid #CCC;
            border-bottom: 1px solid #CCC;
            float: right;

            > h2 {
                text-align: center;
                color: #5f5f5f;
                font-size: 35px;
                letter-spacing: -2px;
                font-weight: 200;
                margin-bottom: 10px;
            }
            p {
                color: #6d6d6d;
                text-align: center;
                font-size: 15px;
                padding: 0 20px;
            }
            .icons {
                width: 33.3%;
                margin: 0 auto;
                .icon {
                    width: 100%;
                    h2 {
                        font-size: 22px;
                    }
                    figure {
                        width: 40%;
                    }
                    &:hover {
                        background-color: #ababab;
                    }
                }
            }
        }
    }

    .el-date-editor.el-input {
        width: 100%;
    }

    .event-select {
        margin-bottom: 15px;
    }

    @media all and (max-width: 1180px) {
        .registration-box .registration-event {
            .icons, .el-form {
                width: 90%;
            }
        }
    }

    @media all and (max-width: 960px) {
        .registration-box {
            width: 90%;
            .registration-event p {
                font-size: 14px;
            }
        }
    }

    @media all and (max-width: 768px) {
        .forms,
        .registration-box {
            width: 100%;
            .icons .icon h2 {
                font-size: 20px;
            }
            .registration-event {
                float: none;
                border: none;
                padding: 20px 0;
            }
        }
        .registration-box {
            margin-top: 0;
            .init-text {
                width: 100%;
                padding: 0 10px;
            }
        }
    }

    @media all and (max-width: 620px) {
        .el-form .el-col-12 {
            width: 100%;
        }
    }
</style>
